import styled from 'styled-components';

export const Container = styled.div`
 width: 90%;

 .bind-mission {
   margin: 0 auto;
   .filter-body {
    display: flex;
    margin-top: 24px;
    align-items: flex-start;
    justify-content: space-between;

    .input-div {
      margin-top: 4px;
    }

    .left-side {
      width: 48%;
      display: flex;
      flex-direction: column;  
    }

    .right-side {
      width: 48%;
      padding-left: 3%;
      border-left: 1px solid var(--gray);
    }

    @media (max-width: 720px) {
      display: flex;
      flex-direction: column;
      width: 100%;
      .left-side, .right-side {
        margin-top: 12px;
        padding: 0;
        width: 100%;
        border: none;

        .input-div {
          margin-bottom: 12px;
        }
      }

    }

   }

   .button-footer {
      margin-top: 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    @media (max-width: 720px) {
      height: 320px;
      width: 110%;
      .button-footer {
        h3 {
          padding-left: 34px;
          width: 115%;
          text-align: end;
          margin-bottom: 10px;
        }
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }

    }
 }
`;
